// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__yQk0N","content":"GlobalSearch_content__3E3Qg"};